var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuStatistichePalestra({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.08,98.19h31.28c1.74,0,3.33,1,4.07,2.58l26.16,85.3c1.75,3.7,7.12,3.34,8.36-.56L121.34,14.49c1.29-4.04,6.95-4.22,8.49-.27l19.94,81.1c.67,1.73,2.34,2.87,4.2,2.87h29.96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStatistichePalestra);
export default __webpack_public_path__ + "static/media/menu-statistiche-palestra.56699b46f2364f07e2133278d2ac655c.svg";
export { ForwardRef as ReactComponent };